module.exports = __webpack_public_path__ + "img/pickup point (1).8437766e.svg";